const BASE_URL = `http://192.168.0.167/phoenix/public/api`;

// Stagging URL

// const BASE_URL = `https://appdevprojects.co/phoenix/public/api`

const Apis = {
  //Auth
  login: `${BASE_URL}/signIn`,
  signUp: `${BASE_URL}/signUp`,
  verifySignUpOtp: `${BASE_URL}/verifySignUpOtp`,
  sendVerificationOtp: `${BASE_URL}/sendVerificationOtp`,
  verifyForgotPasswordCode: `${BASE_URL}/verifyForgotPasswordCode`,
  resetPassword: `${BASE_URL}/resetPassword`,

  // pages
  pages: (type) => `${BASE_URL}/pages?type=${type}`,

  //Change password
  changePassword: `${BASE_URL}/changePassword`,
  contactUs: `${BASE_URL}/contactUs`,
  emailNotification: `${BASE_URL}/updateSettings`,

  // **********************************************DealerShip**********************************************
  getUserData: `${BASE_URL}/dealership/getUserData`,
  updateProfile: `${BASE_URL}/dealership/updateProfile`,
  accountSetup: `${BASE_URL}/dealership/accountSetup`,
  updateCompanyProfile: `${BASE_URL}/dealership/updateCompanyProfile`,
  createAsset: `${BASE_URL}/dealership/createAsset`,
  singleAssets: `${BASE_URL}/dealership/singleAssets`,
  singleAssetsDetails: (id) => `${BASE_URL}/dealership/assetDetail/${id}`,
  downlink: `${BASE_URL}/dealership/assetDownLinkAction`,
  unlinkAssets: `${BASE_URL}/dealership/unlinkedAssets`,

  //modules
  getModules: `${BASE_URL}/dealership/modules`,
  updateAssets: `${BASE_URL}/dealership/updateAsset`,
  deleteAssets: `${BASE_URL}/dealership/deleteAsset`,
  deleteModuleFromAsset : (id) => `${BASE_URL}/dealership/unlinkAssetFromModule/${id}`,

  //Schedule
   createUpdateSchedule: `${BASE_URL}/dealership/updateAssetSchedule`,
   deleteSchedule: `${BASE_URL}/dealership/deleteAssetSchedule`,
   scheduleStatus : (id) => `${BASE_URL}/dealership/updateAssetScheduleStatus/${id}`,

   //Group Asset
   createAssetGroup: `${BASE_URL}/dealership/createAssetGroup`,
   
};
export default Apis;
